import BaseModel from "./base/baseModel";

export default class ConfiguracaoIntegracaoModel extends BaseModel {
    id?: number = null;
    descricao: string = null;
    api_key: string = null;
    franquiaId?: number = null;
}
